import React from 'react';
import Sidebar from 'components/shared/sidebar/component';
import { SIDEBAR_MODE_FACILITATOR } from 'components/constants';
import GamesListing from 'components/manager/facilitator/gamesListing/component';
export default function ViewFacilitatorGames() {
    return (React.createElement("div", null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_FACILITATOR }),
        React.createElement(GamesListing, { isFacilitatorOrigin: true })));
}
